import React from "react";
import "./loading.css";
export const Loading = () => {
  return (
    <div className="loading">
      <h3>Loading...</h3>
    </div>
  );
};
